// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Header_inputSearch__1DM6H","nav":"Header_nav__2dlc2"};